import React from "react";
import { WidgetLoader } from "../widgets";

interface IWidgetModuleLayout {
    children: React.ReactNode;
    loaderCondition: boolean;
    loadingText?: string;
}
const WidgetModuleLayout: React.FC<IWidgetModuleLayout> = ({
    loaderCondition,
    children,
    loadingText = "Loading Data",
}) => {
    return (
        <div className="w-100" style={{ minHeight: "500px" }}>
            {loaderCondition ? (
                <div
                    className="w-100 d-flex flex-column justify-content-center align-items-center"
                    style={{
                        minHeight: "60vh",
                    }}
                >
                    <WidgetLoader loadingText={loadingText} />
                </div>
            ) : (
                children
            )}
        </div>
    );
};

export default WidgetModuleLayout;